import { useRouter } from '@tanstack/react-router'

import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Button from '@mui/material/Button'

import { RouterButton } from 'Common/components/links/routerLinks'

import ErrorPageLayout from './ErrorPageLayout'

export default function ForbiddenPage() {
    const router = useRouter()

    return (
        <ErrorPageLayout
            status={403}
            icon={<LockOutlinedIcon />}
            title="You don't have access to this page"
            description="This item is outside what your role can view or edit. If you think that's wrong, ask your workspace admin to grant access."
            actions={
                <>
                    <RouterButton to="/mywork" variant="contained">
                        Go to My work
                    </RouterButton>
                    <Button variant="outlined" onClick={() => router.history.back()}>
                        Go back
                    </Button>
                </>
            }
        />
    )
}
